/**
 * Recipient list → CSV download (#1911).
 *
 * "Exportable" is one third of the first send gate. Reviewing nine hundred
 * addresses inside a scrolling panel is not review; the list has to be able to
 * leave the console so a second person can read it, diff it against a previous
 * send, or paste it into the ticket that authorised the mail.
 */

/** Escapes per RFC 4180 — an address is user data and can contain a quote. */
function csvCell(value: string): string {
  return `"${value.replaceAll('"', '""')}"`;
}

export interface ExportableRecipient {
  readonly account_id: string;
  readonly email: string;
}

export function recipientsToCsv(rows: readonly ExportableRecipient[]): string {
  const lines = ['account_id,email', ...rows.map((row) => `${csvCell(row.account_id)},${csvCell(row.email)}`)];
  return `${lines.join('\n')}\n`;
}

/**
 * Trigger a browser download. Kept separate from `recipientsToCsv` so the
 * formatting is testable without a DOM: the part worth asserting is the escape
 * rule, not that an anchor was clicked.
 */
export function downloadRecipientsCsv(
  rows: readonly ExportableRecipient[],
  filename: string,
): void {
  const blob = new Blob([recipientsToCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
